export default {
    attributes: {
      
      proveedor:{
        model:'supplier',
        required: true
      },
      material:{
        model: 'materials',
        required:true
      },
      montoCompra:{
        type:'number',
        required:true
      },
      divisaCompra:{
        type:'string',
        required:true
      },
      folioCompra: {
        type: 'string',
        required: true,
      },
      customerId:{
        model:'cliente',
        required:true
      },
      montoVenta:{
        type:'number',
        required:true
      },
      divisaVenta:{
        type:'string',
        required:true
      },
      folioVenta: {
        type: 'string',
      },
      quote: {
        model: 'quote',
      },
    },
    }



// WEBPACK FOOTER //
// ./src/models/ProfitAndLoses.js